import Dispatcher from '../dispatcher';
import { actions } from '../constants/last_used_configurator/actions';

export const setValueAction = (lastUsedConfigurator) => Dispatcher.handleLastUsedConfiguratorAction({
    type: actions.SET_VALUE,
    payload: lastUsedConfigurator,
});

export const setCartProductFlagAction = (hasCartProduct) => Dispatcher.handleLastUsedConfiguratorAction({
    type: actions.SET_CART_FLAG_VALUE,
    payload: hasCartProduct,
});

export const setIsVehicleProvidedAction = (isVehicleProvided) => Dispatcher.handleLastUsedConfiguratorAction({
    type: actions.SET_IS_VEHICLE_PROVIDED,
    payload: isVehicleProvided,
});

export const setVehicleNotProvidedCommentAction = (vehicleNotProvidedComment) => Dispatcher.handleLastUsedConfiguratorAction({
    type: actions.SET_VEHICLE_NOT_PROVIDED,
    payload: vehicleNotProvidedComment,
});

export const setDispatcher = (configuratorDispatcher) => Dispatcher.handleLastUsedConfiguratorAction({
    type: actions.SET_DISPATCHER,
    payload: configuratorDispatcher,
});
